import React from 'react';

import FileUploadIcon from '@mui/icons-material/FileUpload';

import AppBaseBlockButton, { ICustomButtonProps } from './AppBaseBlockButton';

export function AppUploadBlockButton(props: ICustomButtonProps) {
  return (
    <AppBaseBlockButton {...props}>
      <FileUploadIcon />
    </AppBaseBlockButton>
  );
}

export default AppUploadBlockButton;
